@import "../../variables.scss";

.form {
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 991px) {
    padding: 0 !important;
  }

  @media (min-width: 992px) {
    min-height: 550px;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #555;
      border-radius: 10px;
    }
  }
}

.imageBackground {
  position: relative;
  @media (max-width: 991px) {
    margin-bottom: 30px;
    margin-top: 15px;
    padding: 0;
  }
}

.imageBackground:after {
  content: "";
  width: 2032px;
  height: 1296px;
  background-color: $color-background-blue;
  position: absolute;
  left: -278%;
  top: -541px;
  border-radius: 50%;

  @media (max-width: 1200px) {
    left: -350%;
  }
  @media (max-width: 991px) {
    left: -44%;
    top: -75%;
    width: 200%;
    height: 193%;
  }
}


.image {
  position: absolute;
  bottom: -416px;
  left: 156px;
  @media (max-width: 1200px) {
    bottom: -394px;
  }
}

.optOut {
  &__image {
    position: absolute;
    bottom: -340px;
    left: 180px;
    @media (max-width: 1200px) {
      left: 100px;
    }
  }
}

.healthAndDisability {
  &__image {
    position: absolute;
    top: 170px;
    left: 45px;
    @media (max-width: 1200px) {
      left: -45px;
    }
  }
}

.contract {
  &__image {
    position: absolute;
    top: 190px;
    left: 207px;
    @media (max-width: 1200px) {
      left: 125px;
    }
  }
}

.location {
  &__image {
    position: absolute;
    top: 230px;
    left: 207px;
    @media (max-width: 1200px) {
      left: 125px;
    }
  }
}

.profilepicture {
  &__image {
    position: absolute;
    top: 175px;
    left: 0;
  }
}


.workType {
  &__image {
    position: absolute;
    top:200px;
    left: 207px;
    @media (max-width: 1200px) {
      left: 125px;
    }
  }
}

.rtw {
  &__image {
    position: absolute;
    top: 190px;
    left: 140px;
    @media (max-width: 1200px) {
      top: 210px;
      left: 45px;
    }
  }
}

.jobRequirements {
  &__image {
    position: absolute;
    top: 230px;
    left: 70px;
    @media (max-width: 1200px) {
      top: 240px;
      left: 0;
    }
  }
}

.jobOnboarding {
  &__image {
    position: absolute;
    top: 180px;
    left: 70px;
    @media (max-width: 1200px) {
      top: 180px;
      left: 0;
    }
  }
}



.cvOrWorkHistory {
  &__image {
    position: absolute;
    bottom: -376px;
    left: 146px;
    @media (max-width: 1200px) {
      bottom: -364px;
    }
  }
}

.emergencyContact {
  &__image {
    position: absolute;
    bottom: -416px;
    left: 20px;
    @media (max-width: 1200px) {
      bottom: -394px;
    }
  }
}

.demographics {
  position: absolute;
  bottom: -416px;
  left: 20px;
  @media (max-width: 1200px) {
    bottom: -394px;
  }
}

.personalityTest {
  &__image {
    position: absolute;
    top: 210px;
    left: 130px;
    @media (max-width: 1200px) {
      top: 210px;
      left: 50px;
    }
  }
}


.actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;

  a:hover {
    text-decoration: none;
  }

  button {
    width: 140px;

    &:hover {
      text-decoration: none;
    }
  }
}

.workHistory__link {
  color: $color-bright-blue;
  text-decoration: underline;
  cursor: pointer;
}

.smoothAppear {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;

  &__show {
    max-height: 200px;
    opacity: 1;
  }
}

.titleGrey {
  color: $color-dark-grey;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.signature {
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
}

.location__addressListContainer {
  border: 1px solid $color-light-grey;
  border-radius: 4px;
  position: relative;
  padding-bottom: 33px;
}

.location__notListedBtn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 10px;
  text-align: left;
  background-color: $color-not-listed-btn-grey;
  border: none;
  color: #024798;
  text-decoration: underline;
}
